export default "__VITE_ASSET__B6IPud$V__"